<app-breadcrumb [title]="'Editar Persona'" [items]="['Activos']" [active_item]="'Editar'"></app-breadcrumb>

<!-- Skeleton loader mientras carga -->
<div *ngIf="loading" class="col-sm-12 col-xl-12">
  <ngb-accordion [closeOthers]="true">
    <ngb-panel>
      <ng-template ngbPanelTitle>
        <i class="fa fa-info-circle"></i>
        <span class="ms-2">Datos Básicos</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-body">
            <div class="row g-3 mb-3">
              <!-- Skeleton fields -->
              <div class="col-md-3" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]">
                <div class="skeleton skeleton-label mb-2"></div>
                <div class="skeleton skeleton-input"></div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <!-- Skeleton para otros paneles -->
    <ngb-panel *ngFor="let panel of [1, 2, 3, 4, 5]">
      <ng-template ngbPanelTitle>
        <div class="skeleton skeleton-text" style="width: 150px"></div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>

<div class="col-sm-12 col-xl-12" [hidden]="loading">
  <ngb-accordion [closeOthers]="true" [activeIds]="activePanel" [destroyOnHide]="false" #accordion="ngbAccordion">
    <ngb-panel id="static-1">
      <ng-template ngbPanelTitle>
        <i class="fa fa-info-circle"></i>
        <span (click)="togglePanel('static-1')" class="ms-2">Datos Básicos</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-body">
            <form [ngClass]="{ 'was-validated': validate }" class="needs-validation" novalidate (ngSubmit)="saveData()">
              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="tipo"><strong>Tipo de Documento:</strong><a
                      class="text-danger">*</a></label>
                  <select id="tipo" #inputTipo class="form-select" [(ngModel)]="formData.tipo" name="tipo" required
                    #tipoSelect="ngModel" placeholder="Selecciona una opción"
                    [ngClass]="{ 'is-invalid': errores.tipo }">
                    <option *ngFor="let opcion of TipoDeDocumento" [value]="opcion.value">
                      {{ opcion.label }}
                    </option>
                  </select>

                  <div class="invalid-feedback" *ngIf="errores.tipo">
                    {{ errores.tipo }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="cedula"><strong>Número de Documento:</strong><a
                      class="text-danger">*</a></label>
                  <input #inputCedula class="form-control" id="cedula" type="number" placeholder="Número de documento"
                    [(ngModel)]="formData.cedula" name="cedula" required [ngClass]="{ 'is-invalid': errores.cedula }" />
                  <div class="invalid-feedback" *ngIf="errores.cedula">
                    {{ errores.cedula }}
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="lugarex"><strong>Lugar de Expedición:</strong></label>
                  <ng-select id="lugarex" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                    placeholder="Selecciona una opción" class="js-example-placeholder-multiple" name="lugarex"
                    [(ngModel)]="formData.lugarex"></ng-select>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="primernombre">
                    <strong>Primer Nombre:</strong>
                    <span class="text-danger">*</span>
                  </label>
                  <input #inputPrimernombre class="form-control" id="primernombre" type="text"
                    placeholder="Ingrese primer nombre" [(ngModel)]="formData.primernombre" name="primernombre" required
                    [ngClass]="{ 'is-invalid': errores?.primernombre }" (keypress)="soloLetras($event)" />
                  <div class="invalid-feedback" *ngIf="errores?.primernombre">
                    {{ errores.primernombre }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01"><strong>Segundo Nombre:</strong></label>
                  <input class="form-control" id="segundonombre" type="text" placeholder="Ingrese segundo nombre"
                    [(ngModel)]="formData.segundonombre" name="segundonombre" (keypress)="soloLetras($event)" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Primer Apellido:</strong><a class="text-danger">*</a></label>
                  <input #inputPapellidos class="form-control" id="papellidos" type="text"
                    placeholder="Ingrese primer apellido" [(ngModel)]="formData.papellidos" name="papellidos" required
                    [ngClass]="{ 'is-invalid': errores.papellidos }" (keypress)="soloLetras($event)" />
                  <div class="invalid-feedback" *ngIf="errores.papellidos">
                    {{ errores.papellidos }}
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="Ingrese segundo apellido"><strong>Segundo Apellido:</strong></label>
                  <input class="form-control" id="seapellidos" type="text" placeholder="ingrese segundo apellido"
                    [(ngModel)]="formData.seapellidos" name="seapellidos" (keypress)="soloLetras($event)" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="fechanace">
                    <strong>Fecha de Nacimiento:</strong><a class="text-danger">*</a>
                  </label>
                  <div class="input-group input-group-sm">
                    <input #inputFechanacimiento type="date" id="fechanace" class="form-control form-control-lg fs-14"
                      [(ngModel)]="formData.fechanacimiento" (change)="onDateChange($event.target.value, 'fechanace')"
                      name="fechanace" required [ngClass]="{ 'is-invalid': errores.fechanace }"
                      [max]="fechaMaximaPermitida" />
                    <div class="invalid-feedback" *ngIf="errores.fechanace">
                      {{ errores.fechanace }}
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="edad"><strong>Edad:</strong></label>
                  <div class="input-group bootstrap-touchspin">
                    <input type="number" id="edad" class="form-control" [(ngModel)]="formData.edad" name="edad" readonly
                      disabled />
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Lugar de Nacimiento:</strong></label>
                  <ng-select id="lugarnace" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.lugarnace" name="lugarnace">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="genero"><strong>Género:</strong></label>
                  <select id="genero" #inputGenero class="form-select" [(ngModel)]="formData.genero" name="genero"
                    #tipoSelect="ngModel" [ngClass]="{ 'is-invalid': errores.genero }">
                    <option *ngFor="let opcion of Genero" [value]="opcion.label">
                      {{ opcion.label }}
                    </option>
                  </select>

                  <div class="invalid-feedback" *ngIf="errores.genero">
                    {{ errores.genero }}
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="civil"><strong>Estado Civil:</strong></label>
                  <select id="civil" #inputEstadocivil class="form-select" [(ngModel)]="formData.civil" name="civil"
                    #tipoSelect="ngModel" placeholder="Selecciona una opción"
                    [ngClass]="{ 'is-invalid': errores.civil }">
                    <option *ngFor="let opcion of dataCiviles" [value]="opcion.id">
                      {{ opcion.descripcion }}
                    </option>
                  </select>

                  <div class="invalid-feedback" *ngIf="errores.civil">
                    {{ errores.civil }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01">
                    <strong>Tipo de sangre:</strong>
                  </label>
                  <ng-select id="sangre" [items]="TipoDeSangre" bindLabel="label" bindValue="label"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.sangre" name="sangre">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Dirección:</strong></label>
                  <input id="direccion" class="form-control" type="text" placeholder="Ingrese dirección"
                    [(ngModel)]="formData.direccion" name="direccion" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Ciudad:</strong></label>
                  <ng-select id="ciudad" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.ciudad" name="ciudad">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Barrio:</strong></label>
                  <input class="form-control" id="barrio" type="text" placeholder="Ingrese barrio"
                    [(ngModel)]="formData.barrio" name="barrio" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="civil"><strong>Estrato:</strong></label>
                  <select id="estrato" #inputEstratos class="form-select" [(ngModel)]="formData.estrato" name="estrato"
                    #tipoSelect="ngModel" placeholder="Selecciona una opción"
                    [ngClass]="{ 'is-invalid': errores.estrato }">
                    <option *ngFor="let opcion of Estrato" [value]="opcion.value">
                      {{ opcion.label }}
                    </option>
                  </select>

                  <div class="invalid-feedback" *ngIf="errores.estrato">
                    {{ errores.estrato }}
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=" "><strong>Teléfono Fijo:</strong></label>
                  <input class="form-control" id="telfijo" type="text" placeholder="Ingrese teléfono fijo"
                    [(ngModel)]="formData.telfijo" name="telfijo" maxlength="10" (input)="validarTelefono($event)" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Teléfono Celular:</strong></label>
                  <input class="form-control" id="telcel" type="text" placeholder="Ingrese teléfono celular"
                    [(ngModel)]="formData.telcel" name="telcel" maxlength="10"
                    (input)="validarTelefonoCelular($event)" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Celular Empresarial:</strong></label>
                  <input class="form-control" id="telempresa" type="text" placeholder="Ingrese celular empresarial"
                    [(ngModel)]="formData.telempresa" name="teleempresa" maxlength="10"
                    (input)="validarteleempresa($event)" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="mail"><strong>Correo Electrónico:</strong></label>
                  <input #inputGmail class="form-control" id="mail" type="email"
                    placeholder="Ingrese correo electrónico" [(ngModel)]="formData.mail" name="mail"
                    (input)="validarCorreo()" />
                  <div class="text-danger" *ngIf="errores.mail">
                    {{ errores.mail }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Entidad Bancaria:</strong></label>
                  <ng-select id="banco" [items]="bancos" bindLabel="bancos" bindValue="nit"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.banco" name="banco">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="">
                    <strong>Tipo de Cuenta:</strong></label>
                  <ng-select id="tipocuenta" [items]="TipoDeCuenta" bindLabel="label" bindValue="label"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.tipocuenta" name="tipocuenta">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Número de Cuenta:</strong></label>
                  <input class="form-control" id="cuenta" type="number" placeholder="Ingrese numero de cuenta"
                    [(ngModel)]="formData.cuenta" name="cuenta" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="raza"><strong>Raza o grupo étnico:</strong></label>
                  <select id="raza" #inputRaza class="form-select" [(ngModel)]="formData.raza" name="raza"
                    #tipoSelect="ngModel" placeholder="Selecciona una opción"
                    [ngClass]="{ 'is-invalid': errores.raza }">
                    <option *ngFor="let opcion of dataRaza" [value]="opcion.id">
                      {{ opcion.descripcion }}
                    </option>
                  </select>

                  <div class="invalid-feedback" *ngIf="errores.raza">
                    {{ errores.raza }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="vivienda"><strong>Tipo de Vivienda:</strong></label>
                  <select id="vivienda" #inputTipodevivienda class="form-select" [(ngModel)]="formData.vivienda"
                    name="vivienda" #tipoSelect="ngModel" placeholder="Selecciona una opción"
                    [ngClass]="{ 'is-invalid': errores.vivienda }">
                    <option *ngFor="let opcion of TipoDeVivienda" [value]="opcion.id">
                      {{ opcion.nombre }}
                    </option>
                  </select>

                  <div class="invalid-feedback" *ngIf="errores.vivienda">
                    {{ errores.vivienda }}
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="nucleo"><strong>Núcleo Familiar:</strong></label>
                  <ng-select id="nucleo" [items]="NucleoFamiliar" bindLabel="descripcion" bindValue="id"
                    placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.nucleo" name="nucleo">
                  </ng-select>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Padre de Familia:</strong></label>
                  <ng-select id="padre" [items]="PadreFamiliar" bindLabel="label" bindValue="label"
                    placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.padre" name="padre" (change)="onPadreChange()">
                  </ng-select>
                </div>

                <div *ngIf="formData.padre === 'SI'" class="col-md-3">
                  <label class="form-label" for="nhijos"><strong>Número de Hijos:</strong></label>
                  <input type="number" id="nhijos" class="form-control" [(ngModel)]="formData.nhijos" name="nhijos"
                    placeholder="Ingresa el número de hijos" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01">
                    <strong>Área:</strong></label>
                  <ng-select id="area" [items]="areaData" bindLabel="descripcion" bindValue="id"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.area" name="area">
                  </ng-select>
                </div>
                <!--  <div class="col-md-3">
                  <label class="form-label"  for="">
                    Perfil</label
                  >
                  <ng-select
                    [items]="area"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Seleciona una opción"
                    class="js-example-placeholder-multiple"
                    [(ngModel)]="perfil"
                  >
                  </ng-select>
                </div>
                -->
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Contraseña:</strong></label>
                  <input class="form-control" id="password" type="text" placeholder=" " disabled
                    [(ngModel)]="formData.password" name="password" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="">
                    <strong>Confirme su Contraseña:</strong></label>
                  <input class="form-control" id="" type="text" placeholder=" " disabled />
                </div>
              </div>

              <div class="row g-3 mb-3">
                <div class="mb-3">
                  <label class="form-label" for="observaciones">
                    <strong>Observaciones:</strong></label>
                  <textarea class="form-control" id="observaciones" [(ngModel)]="formData.observaciones"
                    name="observaciones" rows="3"></textarea>
                </div>
              </div>

              <!-- Componente de Firma -->
              <div class="row g-3 mb-3">
                <div class="mb-3">
                  <app-firmas [cedula]="formData.cedula" [firmaExistente]="firmaExistente"
                    (firmaCargada)="onFirmaCargada($event)"></app-firmas>
                </div>
              </div>

              <br />
            </form>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-2">
      <ng-template ngbPanelTitle>
        <i class="fa fa-suitcase"></i><!-- Ícono (puedes cambiar la clase) -->
        <span class="ms-2">Contrato Laboral</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-header">
            <form [ngClass]="{ 'was-validated': validate }" class="needs-validation" novalidate>
              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="condicion">
                    <strong>Condición Laboral:</strong><a class="text-danger">*</a>
                  </label>
                  <select #inputCondicion id="condicion" class="form-select" [(ngModel)]="formData.condicion"
                    name="condicion" required [ngClass]="{ 'is-invalid': errores.condicion }">
                    <option value="" disabled selected>
                      Selecciona una opción
                    </option>
                    <option *ngFor="let opcion of datacondicion" [value]="opcion.value">
                      {{ opcion.label }}
                    </option>
                  </select>
                  <div class="invalid-feedback" *ngIf="errores.condicion">
                    {{ errores.condicion }}
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="cargo">
                    <strong>Cargo del Empleado:</strong>
                    <a class="text-danger">*</a>
                  </label>
                  <select #inputCargos id="cargo" class="form-select" [(ngModel)]="formData.cargo" name="cargo" required
                    (change)="validarCargo()" [ngClass]="{ 'is-invalid': errores.cargo }">
                    <option value="" disabled selected>
                      Selecciona una opción
                    </option>
                    <option *ngFor="let opcion of datacargos" [value]="opcion.id">
                      {{ opcion.cargos }}
                    </option>
                  </select>
                  <div class="invalid-feedback" *ngIf="errores.cargo">
                    {{ errores.cargo }}
                  </div>
                </div>

                <div class="col-md-3" *ngIf="formData.cargo == '2'">
                  <label class="form-label" for="categoria">
                    <strong>Categoría:</strong> <a class="text-danger">*</a>
                  </label>
                  <select #inputCategoria id="categoria" class="form-select" [(ngModel)]="formData.categoria"
                    name="categoria" required (change)="validarCargo()" [ngClass]="{
                      'is-invalid': errores.categoria && validarEnvio,
                    }">
                    <option value="" disabled selected>
                      Seleccione una categoría
                    </option>
                    <option *ngFor="let opcion of Categoria" [value]="opcion.label" [disabled]="opcion.disabled">
                      {{ opcion.label }}
                    </option>
                  </select>
                  <div class="text-danger" *ngIf="errores.categoria && validarEnvio">
                    {{ errores.categoria }}
                  </div>
                </div>

                <div class="col-md-3" *ngIf="formData.cargo == '2'">
                  <label class="form-label" for="numerolic">
                    <strong>Número de Licencia:</strong>
                    <span class="text-danger">*</span>
                  </label>
                  <input #inputNumerolic id="numerolic" type="number" class="form-control fs-14"
                    [(ngModel)]="formData.numerolic" name="numerolic" required (change)="validarCargo()" [ngClass]="{
                      'is-invalid': errores.numerolic && validarEnvio,
                    }" />
                  <div class="invalid-feedback" *ngIf="errores.numerolic && validarEnvio">
                    {{ errores.numerolic }}
                  </div>
                </div>

                <div class="col-md-3" *ngIf="formData.cargo == '2'">
                  <label class="form-label" for="expediciolic">
                    <strong>Fecha Expedición:</strong>
                    <span class="text-danger">*</span>
                  </label>
                  <div class="input-group input-group-sm">
                    <input #inputExpedicioLic id="expediciolic" type="date" class="form-control form-control-lg fs-14"
                      [(ngModel)]="formData.expediciolic" (ngModelChange)="onDateChange($event, 'ExpedicioLic')"
                      name="expediciolic" required [max]="fechaMaximaExpedicion" [ngClass]="{
                        'is-invalid': errores.expediciolic && validarEnvio,
                      }" />
                  </div>
                  <div class="invalid-feedback" *ngIf="errores.expediciolic && validarEnvio">
                    {{ errores.expediciolic }}
                  </div>
                </div>

                <div class="col-md-3" *ngIf="formData.cargo == '2'">
                  <label class="form-label" for="vencelic"><strong>Fecha de Vencimiento:</strong></label>
                  <div class="input-group input-group-sm">
                    <input #inputFechaVenceLic id="vencelic" type="date" class="form-control form-control-lg fs-14"
                      [(ngModel)]="formData.vencelic" (ngModelChange)="onDateChange($event, 'fechaVenceLic')"
                      name="vencelic" required [min]="fechaMinimaPermitida" [ngClass]="{
                        'is-invalid': errores.vencelic && validarEnvio,
                      }" />
                  </div>
                  <div class="invalid-feedback" *ngIf="errores.vencelic && validarEnvio">
                    {{ errores.vencelic }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Tipo de Contrato:</strong></label>
                  <ng-select id="tipocontrato" [items]="tipocontratoData" bindLabel="descripcion" bindValue="id"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.tipocontrato" name="tipocontrato">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Jornada Laboral:</strong></label>
                  <ng-select id="jornada" [items]="JornadaLaboral" bindLabel="label" bindValue="label"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.jornada" name="jornada">
                  </ng-select>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="fechacontrato"><strong>Firma de Contrato:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="firmacontrato" type="date" class="form-control form-control-lg fs-14"
                      [(ngModel)]="formData.firmacontrato" name="firmacontrato" [max]="fechaMaximaExpedicion"
                      (ngModelChange)="onDateChange($event, 'FirmaContrato')" />
                  </div>
                  <div class="valid-feedback">¡Se ve bien!</div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="vencecontrato"><strong>Vencimiento de Contrato:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="vencecontrato" type="date" class="form-control form-control-lg fs-14"
                      [(ngModel)]="formData.vencecontrato" name="vencecontrato" [min]="fechaMinimaPermitida"
                      (ngModelChange)="onDateChange($event, 'VenceContrato')" />
                  </div>
                  <div class="valid-feedback">¡Se ve bien!</div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Lugar de Trabajo:</strong></label>
                  <ng-select id="lugartrabajo" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.lugartrabajo" name="lugartrabajo">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Sueldo:</strong></label>
                  <input class="form-control" id="sueldo" type="number" placeholder="Ingrese sueldo"
                    [(ngModel)]="formData.sueldo" name="sueldo" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01">
                    <strong>Asume Seguridad Social:</strong></label>
                  <ng-select id="asumess" [items]="seguridadsocialData" bindLabel="descripcion" bindValue="id"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.asumess" name="asumess">
                  </ng-select>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01"><strong>Consulta PONAL:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="fechaponal" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                      [(ngModel)]="formData.fechaponal" name="fechaponal"
                      (ngModelChange)="onDateChange($event, 'FechaPonal')" />
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="resultadoponal"><strong>Resultado PONAL:</strong></label>
                  <ng-select id="resultadoponal" [items]="ResultadoPonal" bindLabel="label" bindValue="label"
                    placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.resultadoponal" name="resultadoponal" (change)="onChangeResultado()">
                  </ng-select>
                </div>

                <div class="col-md-3" *ngIf="formData.resultadoponal === 'CON ANTECEDENTES'">
                  <label class="form-label" for="resultadoponal">
                    <strong>ANTECEDENTES PONAL:</strong></label>
                  <input id="anteponal" type="text" class="form-control" placeholder="Ingrese antecedentes ponal"
                    [(ngModel)]="formData.anteponal" name="anteponal" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Consulta PROCURADURIA:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="fechaprocu" class="form-control form-control-lg fs-14" type="date"
                      placeholder="yyyy-mm-dd" [(ngModel)]="formData.fechaprocu" name="fechaprocu"
                      (ngModelChange)="onDateChange($event, 'FechaProcu')" />
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Resultado PROCURADURIA:</strong></label>
                  <ng-select id="resultadoprocu" [items]="ResultadoPonal" bindLabel="label" bindValue="label"
                    placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.resultadoprocu" name="resultadoprocu">
                  </ng-select>
                </div>
                <div class="col-md-3" *ngIf="formData.resultadoprocu === 'CON ANTECEDENTES'">
                  <label class="form-label" for="anteprocu"><strong>ANTECEDENTES PROCURADURIA:</strong></label>
                  <input id="anteprocu" class="form-control" placeholder="Ingrese antecedentes procuraduria"
                    [(ngModel)]="formData.anteprocu" name="anteprocu" />
                </div>

                <!-- <div class="container mt-4">
                  <div class="card">
                    <div class="card-header bg-primary text-white text-center">
                      <h5>Sube tus documentos</h5>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div *ngFor="let dropzone of dropzones" class="col-12 col-sm-6 col-md-3 mb-3">
                          <div class="dropzone">
                            <input type="file" class="d-none" (change)="onFileChange($event, dropzone.id)"
                              id="fileInput{{ dropzone.id }}">

                            <label for="fileInput{{ dropzone.id }}" class="dropzone-label">
                              <div class="dropzone-preview">
                                <img *ngIf="dropzone.file" [src]="dropzone.file.preview" class="preview-img">
                                <p *ngIf="!dropzone.file">{{ dropzone.name }}</p>
                              </div>
                            </label>

                            <div *ngIf="dropzone.file" class="delete-btn">
                              <button class="btn btn-danger btn-sm" (click)="removeFile(dropzone.id)">Eliminar</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </form>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-3">
      <ng-template ngbPanelTitle>
        <i class="fa fa-child"></i>
        <span class="ms-2">Dotación</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-header">
            <form [ngClass]="{ 'was-validated': validate }" class="needs-validation" novalidate>
              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01">
                    <strong>Talla Camisa:</strong></label>
                  <input class="form-control" id="camisa" type="text" placeholder="Ingrese talla"
                    [(ngModel)]="formData.camisa" name="camisa" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Talla Pantalón:</strong></label>
                  <input class="form-control" id="pantalon" type="text" placeholder="Ingrese talla"
                    [(ngModel)]="formData.pantalon" name="pantalon" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Talla Zapatos:</strong></label>
                  <input class="form-control" id="zapatos" type="text" placeholder="Ingrese talla"
                    [(ngModel)]="formData.zapatos" name="zapatos" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="peso"><strong>Peso (KG):</strong></label>
                  <input class="form-control" id="peso" type="number" [(ngModel)]="formData.peso"
                    (keyup)="calcularIMC()" name="peso" placeholder="Ingrese su peso" />
                </div>
              </div>

              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="altura"><strong>Altura (CM):</strong></label>
                  <input class="form-control" id="altura" type="number" [(ngModel)]="formData.altura"
                    (blur)="calcularIMC()" name="altura" placeholder="Ingrese su altura en cm" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="imc"><strong>IMC:</strong></label>
                  <input class="form-control" id="imc" type="text" [(ngModel)]="formData.imc" name="imc" disabled />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="resultadoimc"><strong>Resultado IMC:</strong></label>
                  <input class="form-control" id="resultadoimc" type="text" [(ngModel)]="formData.resultadoimc"
                    name="resultadoimc" disabled />
                </div>
              </div>

              <br />
            </form>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-4">
      <ng-template ngbPanelTitle>
        <i class="fa fa-medkit"></i>
        <span class="ms-2">Seguridad Social</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <form [ngClass]="{ 'was-validated': validate }" class="needs-validation" novalidate (ngSubmit)="saveData()">
            <div class="card card-absolute">
              <div class="card-header bg-primary">
                <h5 class="text-white">EPS</h5>
              </div>
              <div class="card-body">
                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <label class="form-label" for="eps"><strong>Entidad</strong></label>
                    <ng-select id="eps" [items]="empresas" bindLabel="nombre" bindValue="nit"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      [(ngModel)]="formData.eps" (click)="filtrarPorEps()" name="eps">
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="fechaeps"><strong>Fecha de Afiliación:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechaeps" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechaeps" name="fechaeps" [max]="fechaMaximaExpedicion"
                        (ngModelChange)="onDateChange($event, 'FechaEps')" />
                    </div>
                    <div class="valid-feedback">¡Se ve bien!</div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="fechacobeps"><strong>Fecha de Cobertura:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechacobeps" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechacobeps" name="fechacobeps" [min]="fechaMinimaPermitida"
                        (ngModelChange)="onDateChange($event, 'FechaCobEps')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-absolute">
              <div class="card-header bg-primary">
                <h5 class="text-white">ARL</h5>
              </div>
              <div class="card-body">
                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <label class="form-label" for="arl"><strong>Entidad</strong></label>
                    <ng-select id="arl" [items]="empresaARL" bindLabel="nombre" bindValue="nit"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      [(ngModel)]="formData.arl" (click)="filtrarPorArl()" name="arl">
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="">
                      <strong>Fecha de Afiliación:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechaarl" type="date" class="form-control form-control-lg" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechaarl" name="fechaarl" [max]="fechaMaximaExpedicion"
                        (ngModelChange)="onDateChange($event, 'FechaArl')" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                      <strong>Fecha de Cobertura:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechacobarl" type="date" class="form-control form-control-lg" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechacobarl" name="fechacobarl" [min]="fechaMinimaPermitida"
                        (ngModelChange)="onDateChange($event, 'FechaCobArl')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-absolute">
              <div class="card-header bg-primary">
                <h5 class="text-white">FONDO DE PENSIONES</h5>
              </div>
              <div class="card-body">
                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <label class="form-label" for="afp">
                      <strong>Entidad:</strong></label>
                    <ng-select id="afp" [items]="empresaAFP" bindLabel="nombre" bindValue="nit"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      [(ngModel)]="formData.afp" (click)="filtrarPorFondoPensiones()" name="afp">
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                      <strong>Fecha de Afiliación:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechaafp" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechaafp" name="fechaafp" [max]="fechaMaximaExpedicion"
                        (ngModelChange)="onDateChange($event, 'FechaAfp')" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                      <strong>Fecha de Cobertura:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechacobafp" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechacobafp" name="fechacobafp" [min]="fechaMinimaPermitida"
                        (ngModelChange)="onDateChange($event, 'FechaCobAfp')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-absolute">
              <div class="card-header bg-primary">
                <h5 class="text-white">CESANTIAS</h5>
              </div>
              <div class="card-body">
                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <label class="form-label" for="ces"><strong>Entidad:</strong></label>
                    <ng-select id="ces" [items]="empresaCES" bindLabel="nombre" bindValue="nit"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      [(ngModel)]="formData.ces" (click)="filtrarPorCesantias()" name="ces">
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                      <strong>Fecha de Afiliación:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechaces" type="date" class="form-control form-control-lg" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechaces" name="fechaces" [max]="fechaMaximaExpedicion"
                        (ngModelChange)="onDateChange($event, 'FechaCes')" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                      <strong>Fecha de Cobertura:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechacobces" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechacobces" name="fechacobces" [min]="fechaMinimaPermitida"
                        (ngModelChange)="onDateChange($event, 'FechaCobCes')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-absolute">
              <div class="card-header bg-primary">
                <h5 class="text-white">CAJA DE COMPENSACIÓN FAMILIAR</h5>
              </div>
              <div class="card-body">
                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <label class="form-label" for="ccf"><strong>Entidad:</strong></label>
                    <ng-select id="ccf" [items]="empresaCCF" bindLabel="nombre" bindValue="nit"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      [(ngModel)]="formData.ccf" (click)="filtrarPorCajaCompensacion()" name="ccf">
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                      <strong>Fecha de Afiliación:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechaccf" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechaccf" name="fechaccf" [max]="fechaMaximaExpedicion"
                        (ngModelChange)="onDateChange($event, 'FechaCcf')" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="">
                      <strong>Fecha de Cobertura:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechacobeccf" class="form-control form-control-lg fs-14" type="date"
                        [(ngModel)]="formData.fechacobeccf" name="fechacobeccf" [min]="fechaMinimaPermitida"
                        (ngModelChange)="onDateChange($event, 'FechaCobEccf')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-5">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-id-card"></i>
        <span class="ms-2">Multas e infracciones</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-header bg-primary">
            <h5 class="text-uppercase text-white">
              <strong>Listado de Multas e Infracciones</strong>
            </h5>
          </div>
          <div class="card-body custom-datatable noscroll">
            <div class="custom-datatable table-responsive">
              <table class="table table-hover table-bordered" id="tblInfracciones">
                <thead class="bg-primary">
                  <tr>
                    <th class="text-center" (click)="sortData('fecha')">
                      FECHA
                    </th>
                    <th class="text-center" (click)="sortData('tipo')">TIPO</th>
                    <th class="text-center" (click)="sortData('numero')">
                      NÚMERO
                    </th>
                    <th class="text-center" (click)="sortData('codigo_infraccion')">
                      COD. INFRACCIÓN
                    </th>
                    <th class="text-center" (click)="sortData('valor_comparendo')">
                      VR COMPARENDO
                    </th>
                    <th class="text-center" (click)="sortData('valor_pagos')">
                      VR PAGOS
                    </th>
                    <th class="text-center" (click)="sortData('valor_saldos')">
                      VR SALDOS
                    </th>
                    <th class="text-center" (click)="sortData('fecha_compromiso')">
                      FECHA COMPROMISO
                    </th>
                    <th class="text-center" (click)="sortData('estado')">
                      ESTADO
                    </th>
                    <th class="text-center" (click)="sortData('observaciones')">
                      OBSERVACIONES
                    </th>
                    <th class="text-center">ACCIONES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let infraccion of infracciones">
                    <td class="text-center">
                      {{ infraccion.fecha | date: "dd-MM-yyyy" }}
                    </td>
                    <td class="text-center">{{ infraccion.tipo }}</td>
                    <td class="text-center">{{ infraccion.numero }}</td>
                    <td class="text-center">{{ infraccion.codigo }}</td>
                    <td class="text-center">
                      $ {{ infraccion.valortotal | number: "1.0-0" }}
                    </td>
                    <td class="text-center">
                      $ {{ infraccion.vrpagado | number: "1.0-0" }}
                    </td>
                    <td class="text-center">
                      $ {{ infraccion.vrsaldo | number: "1.0-0" }}
                    </td>
                    <td class="text-center">
                      {{ infraccion.fechacompromiso | date: "dd-MM-yyyy" }}
                    </td>

                    <td class="text-center">
                      <span [ngClass]="infraccion.estadoMulta.color">
                        {{ infraccion.estadoMulta?.descripcion }}
                      </span>
                    </td>
                    <td class="text-center">{{ infraccion.observaciones }}</td>
                    <td>
                      <div class="action text-center">
                        <ul class="list-inline">
                          <li class="edit">
                            <a href="javascript:void(0)">
                              <i class="icon-pencil-alt" (click)="openModal1(myModal, infraccion)"
                                ngbTooltip="Editar"></i>
                            </a>
                          </li>
                          <li class="delete" (click)="inactivarInfraccion(infraccion.numero)" ngbTooltip="Inactivar">
                            <a href="javascript:void(0)"><i class="icon-trash"></i></a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-content-between align-items-center mt-4">
                <!-- Selector de registros por página alineado a la izquierda -->

                <!-- Mostrar cantidad total de registros centrado -->
                <div class="text-center flex-grow-1">
                  Total Registros:
                  <a class="badge badge-primary"><b>{{ infracciones.length }}</b></a>
                </div>

                <!-- Paginador alineado a la derecha -->
              </div>
            </div>

            <div class="card-body">
              <div class="btn-showcase text-center">
                <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                  (click)="
                    exportarExcel('tblInfracciones', 'Listado_infracciones')
                  ">
                  <i class="icofont icofont-file-excel"></i> EXCEL
                </button>

                <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                  (click)="
                    exportToPDF(
                      'tblInfracciones',
                      'Listado_infracciones',
                      'Listado de Infracciones'
                    )
                  ">
                  <i class="icofont icofont-file-pdf"></i> PDF
                </button>

                <button class="btn btn-outline-primary-2x" type="button" placement="top"
                  ngbTooltip="Agregar Multa o Infraccion" (click)="openModal1(myModal)">
                  <i class="icofont icofont-plus"></i> Agregar
                </button>

               <ng-template #myModal let-modal>
  <div class="modal-header bg-primary text-white">
    <div>
      <h5 class="modal-title mb-0">
        <i class="bi bi-file-earmark-text me-2"></i>
        {{ editMode ? 'Actualizar' : 'Crear' }} multa e infracción
      </h5>
      <small class="text-white-50">Cédula: {{ formData.cedula }}</small>
    </div>
    <button type="button" class="btn-close btn-close-white" (click)="cerrarModal(modal)" aria-label="Cerrar"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="formInfraccion">

      <!-- Sección: Datos de la infracción -->
      <h6 class="text-uppercase text-dark small fw-bold mb-3">Datos de la infracción</h6>
      <div class="row g-3 mb-4">
        <div class="col-md-3">
          <label for="fecha" class="form-label text-dark">Fecha *</label>
          <input
            id="fecha"
            class="form-control"
            type="date"
            formControlName="fecha"
            [max]="today"
            [class.is-invalid]="formInfraccion.get('fecha')?.invalid && formInfraccion.get('fecha')?.touched"
          />
          <div class="invalid-feedback">La fecha es obligatoria.</div>
        </div>

        <div class="col-md-3">
          <label for="Tipo" class="form-label text-dark">Tipo *</label>
          <select id="Tipo" class="form-select" formControlName="tipo">
            <option value="COMPARENDO">Comparendo</option>
            <option value="FOTOMULTA">Fotomulta</option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="numero" class="form-label text-dark">Número *</label>
          <input
            id="numero"
            class="form-control"
            placeholder="Ej. 05001000000012345"
            type="number"
            formControlName="numero"
            [class.is-invalid]="formInfraccion.get('numero')?.invalid && formInfraccion.get('numero')?.touched"
          />
          <div class="invalid-feedback">Ingresa el número del comparendo.</div>
        </div>

        <div class="col-md-3">
          <label for="Infraccion" class="form-label text-dark">Código infracción *</label>
          <select id="Infraccion" class="form-select" formControlName="codigo">
            <option value="" disabled selected>Selecciona un código</option>
            <option *ngFor="let opcion of codigoinfracciondata" [value]="opcion.codigo">
              {{ opcion.codigo }}
            </option>
          </select>
        </div>
      </div>

      <!-- Sección: Información financiera -->
      <h6 class="text-uppercase text-dark small fw-bold mb-3">Información financiera</h6>
      <div class="row g-3 mb-4">
        <div class="col-md-3">
          <label for="vrComparendo" class="form-label text-dark">Valor comparendo *</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input
              id="vrComparendo"
              class="form-control"
              type="number"
              formControlName="valortotal"
              readonly
            />
          </div>
        </div>

        <div class="col-md-3">
          <label for="vrPagos" class="form-label text-dark">Valor pagado</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input
              id="vrPagos"
              class="form-control"
              type="number"
              formControlName="vrpagado"
              min="0"
            />
          </div>
        </div>

        <div class="col-md-3">
          <label for="vrSaldo" class="form-label text-dark">Saldo actual</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input
              id="vrSaldo"
              class="form-control"
              [class.text-danger]="formInfraccion.get('vrsaldo')?.value > 0"
              [class.fw-bold]="formInfraccion.get('vrsaldo')?.value > 0"
              type="number"
              formControlName="vrsaldo"
              readonly
              min="0"
            />
          </div>
        </div>
      </div>

      <!-- Sección: Seguimiento -->
      <h6 class="text-uppercase text-dark small fw-bold mb-3">Seguimiento</h6>
      <div class="row g-3 mb-2">
        <div class="col-md-3">
          <label for="estado" class="form-label text-dark">Estado actual *</label>
          <select id="estado" class="form-select" formControlName="estado">
            <option *ngFor="let estado of estadosMultas" [value]="estado.id">
              {{ estado.descripcion }}
            </option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="fechaCompromiso" class="form-label text-dark">Fecha compromiso</label>
          <input
            id="fechaCompromiso"
            class="form-control"
            type="date"
            formControlName="fechacompromiso"
          />
        </div>

        <div class="col-md-12 mt-3">
          <label for="observaciones" class="form-label text-dark">Observaciones</label>
          <textarea
            id="observaciones"
            class="form-control"
            rows="3"
            placeholder="Escribe cualquier detalle relevante del caso..."
            formControlName="observaciones"
          ></textarea>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="cerrarModal(modal)">
      Cancelar
    </button>
    <button
      class="btn btn-primary"
      [disabled]="formInfraccion.invalid"
      (click)="guardarInfraccion()"
    >
      <i class="bi" [ngClass]="editMode ? 'bi-check2-circle' : 'bi-save'"></i>
      {{ editMode ? 'Actualizar' : 'Guardar' }}
    </button>
  </div>
</ng-template>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-6" *ngIf="false">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-bed-patient"></i>
        <span class="ms-2">Exámenes médicos</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card"></div>
        <div class="card">
          <div class="card-header d-flex align-items-center bg-primary text-white">
            <h5 class="mb-0 text-uppercase">Listado de exámenes médicos</h5>
          </div>
          <div class="card-body">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active1" (navChange)="onNavChange1($event)" class="nav-tabs">
              <li [ngbNavItem]="1">
                <a ngbNavLink>EXÁMENES REGLAMENTARIOS</a>
                <ng-template ngbNavContent>
                  <div class="card-body custom-datatable noscroll">
                    <div class="custom-datatable table-responsive">
                      <table class="table table-hover table-bordered" id="tblExamenes">
                        <thead class="bg-primary">
                          <tr>
                            <th class="text-center" (click)="sortData('examenes_realizados')">
                              EXÁMENES REALIZADOS
                            </th>
                            <th class="text-center" (click)="sortData('id')">
                              ID
                            </th>
                            <th class="text-center" (click)="sortData('fecha_realizacion')">
                              FECHA REALIZACIÓN
                            </th>
                            <th class="text-center" (click)="sortData('fecha_vencimiento')">
                              FECHA VENCIMIENTO
                            </th>
                            <th class="text-center" (click)="sortData('entidad')">
                              ENTIDAD
                            </th>
                            <th class="text-center">ACCIONES</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let examen of examenes">
                            <td class="text-center align-middle">
                              <div class="d-flex justify-content-center align-items-center">
                                <ul class="list-inline mb-0">
                                  <li class="list-inline-item">
                                    <a href="javascript:void(0)" (click)="toggleTabla(examen.id)">
                                      <i [ngClass]="{
                                          'icon-eye': !cedulasSeleccionadas.has(
                                            examen.id
                                          ),
                                          'icon-close':
                                            cedulasSeleccionadas.has(examen.id),
                                        }"></i>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                            <td class="text-center">{{ examen.id }}</td>
                            <td class="text-center">
                              {{ examen.fecha | date: "dd/MM/yyyy" }}
                            </td>
                            <td class="text-center">
                              {{ examen.vence | date: "dd/MM/yyyy" }}
                            </td>
                            <td class="text-center">{{ examen.entidad }}</td>
                            <td>
                              <div class="action text-center">
                                <ul class="list-inline">
                                  <li class="edit">
                                    <a href="javascript:void(0)">
                                      <i class="icon-pencil-alt" (click)="
                                          openModalExamenes(myModal, examen)
                                        " ngbTooltip="Editar"></i>
                                    </a>
                                  </li>
                                  <li class="delete" (click)="inactivarExamenes(examen.id)" ngbTooltip="Inactivar">
                                    <a href="javascript:void(0)">
                                      <i class="icon-trash"></i>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div class="d-flex justify-content-between align-items-center mt-4">
                        <!-- Selector de registros por página alineado a la izquierda -->
                        <div class="d-flex align-items-center">
                          <label for="pageSize" class="me-2 text-dark">Mostrar:</label>
                          <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">
                              {{ size }}
                            </option>
                          </select>
                          <span class="ms-2">registros por página</span>
                        </div>

                        <!-- Mostrar cantidad total de registros centrado -->
                        <div class="text-center flex-grow-1">
                          Total Registros:
                          <a class="badge badge-primary"><b>{{ propietarios.length }}</b></a>
                        </div>

                        <!-- Paginador alineado a la derecha -->
                        <div class="text-end paginador-personalizado">
                          <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                            [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                          </pagination-controls>
                        </div>
                      </div>
                    </div>

                    <div class="card-body">
                      <div class="btn-showcase text-center">
                        <button class="btn btn-outline-success-2x" type="button" placement="top"
                          ngbTooltip="Exportar a Excel" (click)="
                            exportarExcel('tblExamenes', 'Listado_Examenes')
                          ">
                          <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>

                        <button class="btn btn-outline-danger-2x" type="button" placement="top"
                          ngbTooltip="Exportar a PDF" (click)="
                            exportToPDF(
                              'tblExamenes',
                              'Listado_Examenes',
                              'Listado de Exámenes Médicos'
                            )
                          ">
                          <i class="icofont icofont-file-pdf"></i> PDF
                        </button>

                        <button class="btn btn-outline-primary-2x" type="button" placement="top" ngbTooltip="Crear"
                          (click)="openModalExamenes(myModal)">
                          <i class="icofont icofont-plus"></i> Agregar
                        </button>

                        <ng-template #myModal let-modal>
                          <div class="card border-4 rounded-3">
                            <div
                              class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
                              <h5 class="mb-0">CREAR EXÁMEN MÉDICO</h5>
                            </div>
                            <div class="modal-body">
                              <form>
                                <!-- Inputs antes de la tabla -->
                                <div class="row g-3 mb-3">
                                  <div class="col-md-4">
                                    <label class="form-label">Nombre del Paciente:</label>
                                    <input type="text" class="form-control" placeholder="Ingrese el nombre" />
                                  </div>

                                  <div class="col-md-4">
                                    <label class="form-label">Documento de Identidad:</label>
                                    <input type="text" class="form-control" placeholder="Ingrese el documento" />
                                  </div>

                                  <div class="col-md-4">
                                    <label class="form-label">Fecha de Examen:</label>
                                    <input type="date" class="form-control" />
                                  </div>
                                </div>

                                <!-- Tabla con exámenes -->
                                <div class="table-responsive">
                                  <table class="table table-bordered">
                                    <thead class="table-light">
                                      <tr>
                                        <th>Examen</th>
                                        <th>Realizado</th>
                                        <th>Resultado</th>
                                        <th>Recomendaciones</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>Examen Médico</td>
                                        <td class="text-center">
                                          <input type="checkbox" />
                                        </td>
                                        <td>
                                          <select class="form-control">
                                            <option value="">
                                              SELECCIONE UNA OPCIÓN
                                            </option>
                                            <option value="APTO">APTO</option>
                                            <option value="NO APTO">
                                              NO APTO
                                            </option>
                                          </select>
                                        </td>
                                        <td>
                                          <input type="text" class="form-control" placeholder="Recomendaciones" />
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Exámenes de Laboratorio</td>
                                        <td class="text-center">
                                          <input type="checkbox" />
                                        </td>
                                        <td>
                                          <select class="form-control">
                                            <option value="">
                                              SELECCIONE UNA OPCIÓN
                                            </option>
                                            <option value="APTO">APTO</option>
                                            <option value="NO APTO">
                                              NO APTO
                                            </option>
                                          </select>
                                        </td>
                                        <td>
                                          <input type="text" class="form-control" placeholder="Recomendaciones" />
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Visiometría u Optometría</td>
                                        <td class="text-center">
                                          <input type="checkbox" />
                                        </td>
                                        <td>
                                          <select class="form-control">
                                            <option value="">
                                              SELECCIONE UNA OPCIÓN
                                            </option>
                                            <option value="APTO">APTO</option>
                                            <option value="NO APTO">
                                              NO APTO
                                            </option>
                                          </select>
                                        </td>
                                        <td>
                                          <input type="text" class="form-control" placeholder="Recomendaciones" />
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Audiometría o Fonoaudiología</td>
                                        <td class="text-center">
                                          <input type="checkbox" />
                                        </td>
                                        <td>
                                          <select class="form-control">
                                            <option value="">
                                              SELECCIONE UNA OPCIÓN
                                            </option>
                                            <option value="APTO">APTO</option>
                                            <option value="NO APTO">
                                              NO APTO
                                            </option>
                                          </select>
                                        </td>
                                        <td>
                                          <input type="text" class="form-control" placeholder="Recomendaciones" />
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Coordinación Motriz</td>
                                        <td class="text-center">
                                          <input type="checkbox" />
                                        </td>
                                        <td>
                                          <select class="form-control">
                                            <option value="">
                                              SELECCIONE UNA OPCIÓN
                                            </option>
                                            <option value="APTO">APTO</option>
                                            <option value="NO APTO">
                                              NO APTO
                                            </option>
                                          </select>
                                        </td>
                                        <td>
                                          <input type="text" class="form-control" placeholder="Recomendaciones" />
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Psicología</td>
                                        <td class="text-center">
                                          <input type="checkbox" />
                                        </td>
                                        <td>
                                          <select class="form-control">
                                            <option value="">
                                              SELECCIONE UNA OPCIÓN
                                            </option>
                                            <option value="APTO">APTO</option>
                                            <option value="NO APTO">
                                              NO APTO
                                            </option>
                                          </select>
                                        </td>
                                        <td>
                                          <input type="text" class="form-control" placeholder="Recomendaciones" />
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Osteomuscular</td>
                                        <td class="text-center">
                                          <input type="checkbox" />
                                        </td>
                                        <td>
                                          <select class="form-control">
                                            <option value="">
                                              SELECCIONE UNA OPCIÓN
                                            </option>
                                            <option value="APTO">APTO</option>
                                            <option value="NO APTO">
                                              NO APTO
                                            </option>
                                          </select>
                                        </td>
                                        <td>
                                          <input type="text" class="form-control" placeholder="Recomendaciones" />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </form>
                            </div>

                            <div class="modal-footer">
                              <button class="btn btn-primary">Guardar</button>
                              <button class="btn btn-secondary" (click)="modal.dismiss()">
                                Cancelar
                              </button>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </li>

              <li [ngbNavItem]="2">
                <a ngbNavLink> EXÁMENES TOXICOLOGIA</a>
                <ng-template ngbNavContent>
                  <div class="card-body custom-datatable noscroll">
                    <div class="custom-datatable table-responsive">
                      <table class="table" id="tblProActivo">
                        <thead>
                          <tr>
                            <th class="text-center" (click)="sortData('')">
                              FECHA
                            </th>
                            <th class="text-center" (click)="sortData('')">
                              ENTIDAD
                            </th>
                            <th class="text-center" (click)="sortData('')">
                              TIPO DE EXAMEN
                            </th>
                            <th class="text-center" (click)="sortData('')">
                              RESULTADO
                            </th>
                            <th class="text-center" (click)="sortData('')">
                              RECOMENDACIONES
                            </th>
                            <th class="text-center">ACCIONES</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="
                              let propietario of propietarios || [];
                              trackBy: trackByCedula
                            ">
                            <td class="text-center">
                              {{ propietario.primernombre }}
                            </td>
                            <td class="text-center">
                              {{ propietario.segundonombre }}
                            </td>
                            <td class="text-uppercase text-justify">
                              {{ propietario.apellido }}
                            </td>
                            <td class="text-center">
                              {{ propietario.cedula }}
                            </td>
                            <td class="text-center">
                              {{ propietario.cedula }}
                            </td>
                            <td>
                              <div class="action text-center">
                                <ul class="list-inline">
                                  <li class="edit">
                                    <a href="javascript:void(0)">
                                      <i class="icon-pencil-alt" (click)="
                                          editarPersona(propietario.cedula)
                                        "></i>
                                    </a>
                                  </li>
                                  <li class="delete" (click)="
                                      inactivarPersona(propietario.cedula)
                                    ">
                                    <a href="javascript:void(0)">
                                      <i class="icon-trash"></i>
                                    </a>
                                  </li>
                                  <li></li>
                                </ul>
                              </div>
                            </td>
                          </tr>

                          <!-- Fila adicional para la tabla de exámenes -->
                          <table *ngIf="
                              propietario?.cedula &&
                              cedulasSeleccionadas.has(propietario.cedula)
                            ">
                            <tr>
                              <td colspan="6">
                                <table class="table mt-2">
                                  <thead>
                                    <tr>
                                      <th class="text-center">
                                        EXÁMENES REALIZADOS
                                      </th>
                                      <th class="text-center">REALIZADO</th>
                                      <th class="text-center">RESULTADO</th>
                                      <th class="text-center">
                                        RECOMENDACIONES
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let examen of examenes">
                                      <td class="text-center">
                                        {{ examen.nombre }}
                                      </td>
                                      <td class="text-center">
                                        {{ examen.realizado }}
                                      </td>
                                      <td class="text-center">
                                        {{ examen.resultado }}
                                      </td>
                                      <td class="text-center">
                                        {{ examen.recomendaciones }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </tbody>
                      </table>

                      <div class="d-flex justify-content-between align-items-center mt-4">
                        <!-- Selector de registros por página alineado a la izquierda -->
                        <div class="d-flex align-items-center">
                          <label for="pageSize" class="me-2 text-dark">Mostrar:</label>
                          <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">
                              {{ size }}
                            </option>
                          </select>
                          <span class="ms-2">registros por página</span>
                        </div>

                        <!-- Mostrar cantidad total de registros centrado -->
                        <div class="text-center flex-grow-1">
                          Total Registros:
                          <a class="badge badge-primary"><b>{{ propietarios.length }}</b></a>
                        </div>

                        <!-- Paginador alineado a la derecha -->
                        <div class="text-end paginador-personalizado">
                          <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                            [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                          </pagination-controls>
                        </div>
                      </div>
                    </div>

                    <div class="card-body">
                      <div class="btn-showcase text-center">
                        <button class="btn btn-outline-success-2x" type="button" placement="top"
                          ngbTooltip="Exportar a Excel" (click)="
                            exportarExcel('tblProActivo', 'Listado_activos')
                          ">
                          <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>

                        <button class="btn btn-outline-danger-2x" type="button" placement="top"
                          ngbTooltip="Exportar a PDF" (click)="
                            exportToPDF(
                              'tblProActivo',
                              'Listado_activos',
                              'Listado de Personas Activas'
                            )
                          ">
                          <i class="icofont icofont-file-pdf"></i> PDF
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-7" *ngIf="false">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-people"></i>
        <span class="ms-2">Beneficiarios</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-header bg-primary">
            <h5 class="text-uppercase text-white">Listado de beneficiarios</h5>
          </div>
          <div class="card-body custom-datatable noscroll">
            <div class="custom-datatable table-responsive">
              <table class="table table-hover table-bordered" id="tblBeneficiarios">
                <thead class="bg-primary">
                  <tr>
                    <th class="text-center" (click)="sortData('tipodocumento')">
                      TIPO DE DOCUMENTO
                    </th>
                    <th class="text-center" (click)="sortData('documento')">
                      DOCUMENTO
                    </th>
                    <th class="text-center" (click)="sortData('beneficiarios')">
                      NOMBRES Y APELLIDOS
                    </th>
                    <th class="text-center" (click)="sortData('edad')">EDAD</th>
                    <th class="text-center" (click)="sortData('parentesco')">
                      PARENTESCO
                    </th>
                    <th class="text-center">ACCIONES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let beneficiario of beneficiarios">
                    <td class="text-center">
                      {{ beneficiario.tipodocumento }}
                    </td>
                    <td class="text-center">{{ beneficiario.documento }}</td>
                    <td class="text-center text-uppercase">
                      {{ beneficiario.beneficiarios }}
                    </td>
                    <td class="text-center">{{ beneficiario.edad }}</td>
                    <td class="text-center">{{ beneficiario.parentesco }}</td>
                    <td>
                      <div class="action text-center">
                        <ul class="list-inline">
                          <li class="edit">
                            <a href="javascript:void(0)">
                              <i class="icon-pencil-alt" (click)="
                                  openModalBeneficiario(myModal, beneficiario)
                                "></i>
                            </a>
                          </li>
                          <li class="delete" (click)="
                              inactivarBeneficiario(beneficiario.documento)
                            ">
                            <a href="javascript:void(0)"><i class="icon-trash"></i></a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-content-between align-items-center mt-4">
                <!-- Selector de registros por página alineado a la izquierda -->
                <div class="d-flex align-items-center">
                  <label for="pageSize" class="me-2 text-dark">Mostrar:</label>
                  <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                    <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">
                      {{ size }}
                    </option>
                  </select>
                  <span class="ms-2">registros por página</span>
                </div>

                <!-- Mostrar cantidad total de registros centrado -->
                <div class="text-center flex-grow-1">
                  Total Registros:
                  <a class="badge badge-primary"><b>{{ beneficiarios.length }}</b></a>
                </div>

                <!-- Paginador alineado a la derecha -->
                <div class="text-end paginador-personalizado">
                  <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                    [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                  </pagination-controls>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="btn-showcase text-center">
                <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                  (click)="
                    exportarExcel('tblBeneficiarios', 'Listado_beneficiarios')
                  ">
                  <i class="icofont icofont-file-excel"></i> EXCEL
                </button>

                <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                  (click)="
                    exportToPDF(
                      'tblBeneficiarios',
                      'Listado_beneficiarios',
                      'Listado de Personas Beneficiarias'
                    )
                  ">
                  <i class="icofont icofont-file-pdf"></i> PDF
                </button>
                <button class="btn btn-outline-primary-2x" type="button" placement="top" ngbTooltip="Crear"
                  (click)="openModal1(myModal)">
                  <i class="icofont icofont-plus"></i> Agregar
                </button>

                <ng-template #myModal let-modal>
                  <div class="card border-4 rounded-3">
                    <div
                      class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
                      <h5 class="mb-0">CREAR UN BENEFICIARIO</h5>
                    </div>
                    <div class="modal-body">
                      <form [formGroup]="formBeneficiario">
                        <div *ngFor="let persona of personas; let i = index" class="row g-3 mb-3">
                          <div class="col-md-2">
                            <label for="tipo{{ i }}" class="form-label">Tipo de Documento</label>
                            <ng-select id="tipo{{ i }}" [items]="tipodocumentodata" bindLabel="descripcion"
                              bindValue="id" placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                              name="tipo" formControlName="tipodocumento">
                            </ng-select>
                          </div>
                          <div class="col-md-2">
                            <label for="Documento{{ i }}" class="form-label">Documento</label>
                            <input id="Documento{{ i }}" formControlName="documento" class="form-control"
                              placeholder="Número de Documento" />
                          </div>
                          <div class="col-md-2">
                            <label for="NombresyApellidos{{ i }}" class="form-label">Nombres y Apellidos</label>
                            <input id="NombresyApellidos{{ i }}" formControlName="beneficiarios" class="form-control"
                              placeholder="Nombre Completo" />
                          </div>
                          <div class="col-md-2">
                            <label for="Edad{{ i }}" class="form-label">Edad</label>
                            <input id="Edad{{ i }}" formControlName="edad" type="number" class="form-control"
                              placeholder="Edad" />
                          </div>
                          <div class="col-md-2">
                            <label for="Parentesco{{ i }}" class="form-label">Parentesco</label>
                            <ng-select id="Parentesco{{ i }}" [items]="parentescodata" bindLabel="descripcion"
                              bindValue="id" placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                              name="Parentesco" formControlName="parentesco">
                            </ng-select>
                          </div>
                          <div class="col-md-1 d-flex align-items-end">
                            <div class="d-flex gap-2">
                              <button class="btn btn-outline-primary btn-sm" (click)="agregarPersona()">
                                <i class="icon-plus"></i>
                              </button>
                              <button class="btn btn-outline-danger btn-sm" (click)="eliminarPersona(i)">
                                <i class="icon-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="modal-footer">
                      <button class="btn btn-primary" (click)="guardarBeneficiario()">
                        {{ editMode ? "Actualizar" : "Guardar" }}
                      </button>
                      <button class="btn btn-secondary" (click)="modal.dismiss()">
                        Cancelar
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-8">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-hat-alt"></i>
        <span class="ms-2">Formación Académica</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-header bg-primary">
            <h5 class="text-uppercase text-white">
              Listado de Formación Académica
            </h5>
          </div>
          <div class="card-body custom-datatable noscroll">
            <div class="custom-datatable table-responsive">
              <table class="table table-hover table-bordered" id="tblAcademica">
                <thead class="bg-primary">
                  <tr>
                    <th class="text-center" (click)="sortData('id')">ID</th>
                    <th class="text-center" (click)="sortData('tipoestudio')">
                      TIPO DE ESTUDIO
                    </th>
                    <th class="text-center" (click)="sortData('titulo')">
                      TÍTULO OBTENIDO
                    </th>
                    <th class="text-center" (click)="sortData('tiempo')">
                      NUM AÑOS/ HORAS
                    </th>
                    <th class="text-center" (click)="sortData('entidad')">
                      INSTITUCIÓN
                    </th>
                    <th class="text-center" (click)="sortData('terminacion')">
                      AÑO TERMINACIÓN
                    </th>
                    <th class="text-center">ACCIONES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let academia of academias">
                    <td class="text-center">{{ academia.id }}</td>
                    <td class="text-center">{{ academia.nivel.nombre }}</td>
                    <td class="text-center">{{ academia.titulo }}</td>
                    <td class="text-center">{{ academia.tiempo }}</td>
                    <td class="text-center">{{ academia.entidad }}</td>
                    <td class="text-center">{{ academia.terminacion }}</td>
                    <td>
                      <div class="action text-center">
                        <ul class="list-inline">
                          <li class="edit">
                            <a href="javascript:void(0)">
                              <i class="icon-pencil-alt" (click)="openModalAcademica(myModal, academia)"
                                ngbTooltip="Editar"></i>
                            </a>
                          </li>
                          <li class="delete" (click)="inactivarAcademica(academia.id)" ngbTooltip="Inactivar">
                            <a href="javascript:void(0)"><i class="icon-trash"></i></a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p *ngIf="!academias || academias.length === 0" class="text-center">
                No hay registros académicos disponibles.
              </p>

              <div class="d-flex justify-content-between align-items-center mt-4">
                <!-- Selector de registros por página alineado a la izquierda -->
                <div class="d-flex align-items-center"></div>

                <!-- Mostrar cantidad total de registros centrado -->
                <div class="text-center flex-grow-1">
                  Total Registros:
                  <a class="badge badge-primary"><b>{{ academias.length }}</b></a>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="btn-showcase text-center">
                <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                  (click)="
                    exportarExcel('tblAcademica', 'Listado_Formación_Académica')
                  ">
                  <i class="icofont icofont-file-excel"></i> EXCEL
                </button>

                <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                  (click)="
                    exportToPDF(
                      'tblAcademica',
                      'Listado_Formación_Académica',
                      'Listado de Formación Académica'
                    )
                  ">
                  <i class="icofont icofont-file-pdf"></i> PDF
                </button>
                <button class="btn btn-outline-primary-2x" type="button" placement="top" ngbTooltip="Crear"
                  (click)="openModalAcademica(myModal)">
                  <i class="icofont icofont-plus"></i> Agregar
                </button>

                <ng-template #myModal let-modal>
                  <div class="card border-4 rounded-3">
                    <div
                      class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
                      <h5 class="mb-0">
                        CREAR FORMACIÓN ACADEMICA - {{ formData.cedula }}
                      </h5>
                    </div>
                    <div class="modal-body">
                      <form [formGroup]="formAcademia">
                        <div *ngFor="let persona2 of personas2; let i = index" class="row g-3 mb-3">
                          <div class="col-md-2">
                            <label for="NiveldeEstudio{{ i }}" class="form-label">Nivel de Estudio *:</label>
                            <ng-select id="NiveldeEstudio{{ i }}" [items]="nivelestudiodata" bindLabel="nombre"
                              bindValue="id" placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                              name="tipoestudio" formControlName="tipoestudio">
                            </ng-select>
                          </div>
                          <div class="col-md-2">
                            <label for="TituloObtenido{{ i }}" class="form-label">Título Obtenido *:</label>
                            <input id="TituloObtenido{{ i }}" formControlName="titulo" class="form-control"
                              placeholder="Título Obtenido" />
                          </div>
                          <div class="col-md-2">
                            <label for="AñosHoras{{ i }}" class="form-label">Num Años/Horas</label>
                            <input id="AñosHoras{{ i }}" formControlName="tiempo" class="form-control"
                              placeholder="Años/Horas" />
                          </div>
                          <div class="col-md-2">
                            <label for="Institucion{{ i }}" class="form-label">Institución Educativa *:</label>
                            <input id="Institucion{{ i }}" formControlName="entidad" class="form-control"
                              placeholder="Institución" />
                          </div>
                          <div class="col-md-2">
                            <label for="Terminacion{{ i }}" class="form-label">Año Terminación *:</label>
                            <input id="Terminacion{{ i }}" formControlName="terminacion" class="form-control"
                              placeholder="Año Terminación" />
                          </div>
                          <!-- <div class="col-md-1 d-flex align-items-end">
                            <div class="d-flex gap-2">
                              <button class="btn btn-outline-primary btn-sm" (click)="agregarPersona2()">
                                <i class="icon-plus"></i>
                              </button>
                              <button class="btn btn-outline-danger btn-sm" (click)="eliminarPersona2(i)">
                                <i class="icon-trash"></i>
                              </button>
                            </div>
                          </div> -->
                        </div>
                      </form>
                    </div>
                    <div class="modal-footer">
                      <button class="btn btn-primary" (click)="guardarAcademica()">
                        {{ editMode ? "Actualizar" : "Guardar" }}
                      </button>
                      <button class="btn btn-secondary" (click)="modal.dismiss()">
                        Cancelar
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-9">
      <ng-template ngbPanelTitle>
        <i class="icon-stats-up"></i>
        <span class="ms-2">Experiencia Laboral</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-header bg-primary">
            <h5 class="text-uppercase text-white">
              Listado de Experiencia Laboral
            </h5>
          </div>
          <div class="card-body custom-datatable noscroll">
            <div class="custom-datatable table-responsive">
              <table class="table table-hover table-bordered" id="tblLaboral">
                <thead class="bg-primary">
                  <tr>
                    <th class="text-center" (click)="sortData('id')">ID</th>
                    <th class="text-center" (click)="sortData('empresa')">
                      EMPRESA
                    </th>
                    <th class="text-center" (click)="sortData('cargo')">
                      CARGO
                    </th>
                    <th class="text-center" (click)="sortData('tiempoLaborado')">
                      TIEMPO LABORADO (MESES)
                    </th>
                    <th class="text-center" (click)="sortData('telefono')">
                      TELÉFONO
                    </th>
                    <th class="text-center">ACCIONES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let laboral of laborales">
                    <td class="text-center">{{ laboral.id }}</td>
                    <td class="text-center">{{ laboral.empresa }}</td>
                    <td class="text-center">{{ laboral.cargo }}</td>
                    <td class="text-center">{{ laboral.tiempo }}</td>
                    <td class="text-center">{{ laboral.telefono }}</td>
                    <td>
                      <div class="action text-center">
                        <ul class="list-inline">
                          <li class="edit">
                            <a href="javascript:void(0)">
                              <i class="icon-pencil-alt" (click)="openModalLaboral(myModal, laboral)"
                                ngbTooltip="Editar"></i>
                            </a>
                          </li>
                          <li class="delete" (click)="inactivarLaboral(laboral.id)" ngbTooltip="Inactivar">
                            <a href="javascript:void(0)"><i class="icon-trash"></i></a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-content-between align-items-center mt-4">
                <!-- Selector de registros por página alineado a la izquierda -->

                <!-- Mostrar cantidad total de registros centrado -->
                <div class="text-center flex-grow-1">
                  Total Registros:
                  <a class="badge badge-primary"><b>{{ laborales.length }}</b></a>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="btn-showcase text-center">
                <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                  (click)="
                    exportarExcel('tblLaboral', 'Listado_Experiencia_Laboral')
                  ">
                  <i class="icofont icofont-file-excel"></i> EXCEL
                </button>

                <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                  (click)="
                    exportToPDF(
                      'tblLaboral',
                      'Listado_Experiencia_Laboral',
                      'Listado de Experiencia Laboral'
                    )
                  ">
                  <i class="icofont icofont-file-pdf"></i> PDF
                </button>
                <button class="btn btn-outline-primary-2x" type="button" placement="top" ngbTooltip="Crear"
                  (click)="openModalLaboral(myModal)">
                  <i class="icofont icofont-plus"></i> Agregar
                </button>

                <ng-template #myModal let-modal>
                  <div class="card border-4 rounded-3">
                    <div
                      class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
                      <h5 class="mb-0">
                        {{
                        editMode
                        ? "ACTUALIZAR EXPERIENCIA LABORAL"
                        : "CREAR EXPERIENCIA LABORAL"
                        }}
                        - {{ formData.cedula }}
                      </h5>
                    </div>
                    <div class="modal-body">
                      <form [formGroup]="formLaboral">
                        <div *ngFor="let persona3 of personas3; let i = index" class="row g-3 mb-3">
                          <div class="col-md-3">
                            <label for="Empresa{{ i }}" class="form-label">Empresa</label>
                            <input id="Empresa{{ i }}" formControlName="empresa" class="form-control"
                              placeholder="Empresa" />
                          </div>
                          <div class="col-md-3">
                            <label for="Cargo{{ i }}" class="form-label">Cargo</label>
                            <input id="Cargo{{ i }}" formControlName="cargo" class="form-control" placeholder="Cargo" />
                          </div>
                          <div class="col-md-2">
                            <label for="Laborado{{ i }}" class="form-label">Tiempo Laborado(MESES)</label>
                            <input id="Laborado{{ i }}" formControlName="tiempo" class="form-control"
                              placeholder="Laborado" />
                          </div>
                          <div class="col-md-2">
                            <label for="Telefono{{ i }}" class="form-label">Teléfono</label>
                            <input id="Telefono{{ i }}" formControlName="telefono" class="form-control"
                              placeholder="Teléfono" />
                          </div>
                          <!-- <div class="col-md-1 d-flex align-items-end">
                            <div class="d-flex gap-2">
                              <button class="btn btn-outline-primary btn-sm" (click)="agregarPersona3()">
                                <i class="icon-plus"></i>
                              </button>
                              <button class="btn btn-outline-danger btn-sm" (click)="eliminarPersona3(i)">
                                <i class="icon-trash"></i>
                              </button>
                            </div>
                          </div> -->
                        </div>
                      </form>
                    </div>
                    <div class="modal-footer">
                      <button class="btn btn-primary" (click)="guardarLaboral()">
                        {{ editMode ? "Actualizar" : "Guardar" }}
                      </button>
                      <button class="btn btn-secondary" (click)="modal.dismiss()">
                        Cancelar
                      </button>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-10">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-medical-sign"></i>
        <span class="ms-2">Exámenes Médicos</span>
      </ng-template>

      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-header bg-primary">
            <h5 class="text-uppercase text-white">
              Listado de Exámenes Médicos
            </h5>
          </div>

          <div class="card-body custom-datatable noscroll">
            <div class="custom-datatable table-responsive">
              <table class="table table-hover table-bordered" id="tblExamenes">
                <thead class="bg-primary">
                  <tr>

                    <th class="text-center" (click)="sortData('tipo_examen')">
                      TIPO DE EXAMEN
                    </th>

                    <th class="text-center" (click)="sortData('fecha_realizo')">
                      FECHA REALIZACIÓN
                    </th>

                    <th class="text-center" (click)="sortData('fecha_vencimiento')">
                      FECHA VENCIMIENTO
                    </th>

                    <th class="text-center" (click)="sortData('entidad')">
                      ENTIDAD
                    </th>

                    <th class="text-center">ACCIONES</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="
                      let examen of examenes
                        | paginate
                          : {
                              itemsPerPage: tableSize,
                              currentPage: page,
                              totalItems: count,
                            };
                      let i = index
                    ">

                     <td class="text-center">
                      {{ examen.tipoExamenData?.nombre }}
                    </td>

                    <td class="text-center">
                      {{ examen.fecha_realizo | date: "dd-MM-yyyy" }}
                    </td>

                    <td class="text-center">
                      {{ examen.fecha_vencimiento | date: "dd-MM-yyyy" }}
                    </td>

                    <td class="text-center">
                      {{ examen.empresa?.nombre }}
                    </td>

                    <td>
                      <div class="action text-center">
                        <ul class="list-inline">
                          <li class="edit">
                            <a href="javascript:void(0)">
                              <i class="icon-pencil-alt" (click)="
                                  openModalExamenes(myModalExamen, examen)
                                " ngbTooltip="Editar">
                              </i>
                            </a>
                          </li>

                          <li class="delete" (click)="inactivarExamenes(examen.id)" ngbTooltip="Eliminar">
                            <a href="javascript:void(0)">
                              <i class="icon-trash"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-content-between align-items-center mt-4">
                <div class="text-center flex-grow-1">
                  Total Registros:

                  <a class="badge badge-primary">
                    <b>{{ examenes.length }}</b>
                  </a>
                </div>
              </div>
            </div>

            <!-- PAGINADOR -->

            <div class="d-flex align-items-center">
              <label for="pageSize" class="me-2 text-dark">Mostrar:</label>
              <select id="pageSize" class="form-select w-auto" [(ngModel)]="tableSize" (change)="page = 1">
                <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">
                  {{ size }}
                </option>
              </select>
              <span class="ms-2">registros por página</span>
            </div>

            <div class="text-end paginador-personalizado">
              <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
                previousLabel="Anterior" nextLabel="Siguiente">
              </pagination-controls>
            </div>
            <!-- BOTONES -->

            <div class="card-body">
              <div class="btn-showcase text-center">
                <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
                  (click)="
                    exportarExcel('tblExamenes', 'Listado_Examenes_Medicos')
                  ">
                  <i class="icofont icofont-file-excel"></i>

                  EXCEL
                </button>

                <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
                  (click)="
                    exportToPDF(
                      'tblExamenes',
                      'Listado_Examenes_Medicos',
                      'Listado de Exámenes Médicos'
                    )
                  ">
                  <i class="icofont icofont-file-pdf"></i>

                  PDF
                </button>

                <button class="btn btn-outline-primary-2x" type="button" placement="top" ngbTooltip="Crear"
                  (click)="openModalExamenes(myModalExamen)">
                  <i class="icofont icofont-plus"></i>

                  Agregar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- MODAL -->

       <ng-template #myModalExamen let-modal>
  <div class="card border-4 rounded-3">

    <!-- HEADER -->
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? "ACTUALIZAR EXAMEN MÉDICO" : "CREAR EXAMEN MÉDICO" }}
        - {{ formData.cedula }}
      </h5>
    </div>

    <!-- BODY -->
    <div class="modal-body">
      <form [formGroup]="formExamenes">
        <div class="row g-3">

          <!-- TIPO EXAMEN -->
          <div class="col-md-3">
            <label class="form-label fw-bold">Tipo de Examen:<span class="text-danger"> *</span></label>
            <ng-select
              [items]="tiposExamenProfesiograma"
              bindLabel="nombre"
              bindValue="tipo_examen_id"
              placeholder="Seleccionar"
              [(ngModel)]="tipoExamenSeleccionado"
              (change)="onTipoExamenChange()"
              [ngModelOptions]="{ standalone: true }">
            </ng-select>
          </div>

          <!-- FECHA REALIZACION -->
          <div class="col-md-3">
            <label class="form-label fw-bold">Fecha Realización:<span class="text-danger"> *</span></label>
            <input type="date" formControlName="fecha_realizo" class="form-control"
              [max]="fechaMaximaPermitida" (change)="calcularFechaVencimiento()" />
          </div>

          <!-- FECHA VENCIMIENTO -->
          <div class="col-md-3">
            <label class="form-label fw-bold">Fecha Vencimiento:<span class="text-danger"> *</span></label>
            <input type="date" formControlName="fecha_vencimiento" class="form-control" />
          </div>

          <!-- ENTIDAD -->
          <div class="col-md-3">
            <label class="form-label fw-bold">Centro Medico - IPS:<span class="text-danger"> *</span>  </label>
            <div class="input-group">
              <div class="form-control p-0 border-0">
                <ng-select [items]="empresaData" bindLabel="nombre" bindValue="nit"
                  placeholder="Seleccionar" formControlName="entidad">
                </ng-select>
              </div>
              <button type="button" class="btn btn-primary btn-sm"
                (click)="openModalEmpresa(myModal2)" ngbTooltip="Crear empresa contratista">
                <i class="icofont icofont-plus"></i>
              </button>
            </div>
          </div>

          <!-- EXÁMENES FILTRADOS POR TIPO -->
          <div class="col-12 mt-3">

            <ng-container *ngIf="!tipoExamenSeleccionado">
              <div class="alert alert-primary text-center mt-3">
                <i class="fa fa-info-circle me-2"></i>
                Selecciona un tipo de examen para ver los exámenes disponibles.
              </div>
            </ng-container>

            <ng-container *ngIf="tipoExamenSeleccionado && examenesDataFiltrados?.length > 0">

              <!-- Info del tipo seleccionado -->
              <ng-container *ngFor="let tipo of tiposExamenProfesiograma">
                <ng-container *ngIf="tipo.tipo_examen_id == tipoExamenSeleccionado">
                  <div class="card my-4">
                    <div class="card-header bg-primary">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <h5 class="text-white mb-0">{{ tipo.nombre }}</h5>
                          <small class="text-white">
                            Periodicidad: {{ tipo.periodicidad_meses || 0 }} meses
                          </small>
                        </div>
                        <span class="badge bg-light text-dark">
                          {{ tipo.obligatorio ? 'OBLIGATORIO' : 'OPCIONAL' }}
                        </span>
                      </div>
                    </div>

                    <div class="card-body">
                      <!-- 👇 Itera examenesDataFiltrados, no tipo.examenes -->
<div class="row g-2 align-items-center mb-3 border-bottom pb-3"
  *ngFor="let examen of examenesDataFiltrados">

  <!-- EXAMEN -->
  <div class="col-md-3">
    <label class="form-label fw-bold small mb-1">Examen</label>
    <input type="text" class="form-control form-control-sm" [value]="examen.nombre" readonly />
  </div>

  <!-- DESCRIPCIÓN -->
  <div class="col-md-3">
    <label class="form-label fw-bold small mb-1">Descripción</label>
    <input type="text" class="form-control form-control-sm"
      [value]="examen.descripcion || 'Sin descripción'" readonly />
  </div>

  <!-- ¿SE REALIZÓ? -->
  <div class="col-md-3">
    <label class="form-label fw-bold small mb-1">
      ¿Se realizó? <span class="text-danger">*</span>
    </label>
    <ng-select
      [items]="[{ id: 1, nombre: 'SI' }, { id: 0, nombre: 'NO' }]"
      bindLabel="nombre"
      bindValue="id"
      placeholder="Seleccionar"
      [(ngModel)]="examen.realizo"
      [ngModelOptions]="{ standalone: true }">
    </ng-select>
  </div>

  <!-- DOCUMENTO — todo en una sola línea horizontal -->
 
</div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

            </ng-container>

            <ng-container *ngIf="tipoExamenSeleccionado && examenesDataFiltrados?.length === 0">
              <div class="alert alert-warning text-center mt-3">
                <i class="fa fa-exclamation-triangle me-2"></i>
                Este tipo de examen no tiene exámenes asignados.
              </div>
            </ng-container>

          </div>
        </div>
      </form>
    </div>

    <!-- FOOTER -->
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
      <button class="btn btn-primary" (click)="guardarExamenes()">
        {{ editMode ? "Actualizar" : "Guardar" }}
      </button>
    </div>

  </div>
</ng-template>
      </ng-template>
      <ng-template #myModal2 let-modal>
        <div class="card border-4 rounded-3">
          <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
            <h5 class="mb-0"><strong>CREACIÓN DE ENTIDADES / EMPRESAS</strong></h5>
          </div>
          <div class="modal-body">
            <form [formGroup]="formEmpresa">
              <!-- Inputs antes de la tabla -->
              <div class="row g-3">
                <div class="col-md-3">
                  <label class="form-label" for="nit"><strong>CC / NIT *:</strong></label>
                  <input class="form-control" id="nit" type="number" placeholder="Ingrese CC o NIT"
                    formControlName="nit" (input)="limitarLongitud($event, 10)" [class.is-invalid]="
                formEmpresa.get('nit')?.invalid &&
                (formEmpresa.get('nit')?.touched || validate)
              " />
                  <div *ngIf="
                formEmpresa.get('nit')?.invalid &&
                (formEmpresa.get('nit')?.touched || validate)
              " class="invalid-feedback">
                    Por favor, ingresa un número de documento.
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="digito">
                    <strong>Digito de Verificacción *:</strong></label>
                  <input #inputCodigo class="form-control" id="digito" type="number" required
                    placeholder="Ingrese el dígito de verificación" formControlName="digito" [class.is-invalid]="
                formEmpresa.get('digito')?.invalid &&
                (formEmpresa.get('digito')?.touched || validate)
              " />
                  <div *ngIf="
                formEmpresa.get('digito')?.invalid &&
                (formEmpresa.get('digito')?.touched || validate)
              " class="invalid-feedback">
                    Por favor, ingresa un digito de verificación.
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="nombre"><strong>Nombre Completo/Razon Social *:</strong></label>
                  <input #inputNombre class="form-control" id="nombre" type="text"
                    placeholder="Ingrese el nombre o razon social" required formControlName="nombre" [class.is-invalid]="
                formEmpresa.get('nombre')?.invalid &&
                (formEmpresa.get('nombre')?.touched || validate)
              " />
                  <div *ngIf="
                formEmpresa.get('nombre')?.invalid &&
                (formEmpresa.get('nombre')?.touched || validate)
              " class="invalid-feedback">
                    Por favor, ingresa un nombre o razón social.
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="direccion">
                    <strong>Dirección *:</strong></label>
                  <input #inputDireccion class="form-control" id="direccion" type="text" required
                    placeholder="Ingresa una dirección" formControlName="direccion" [class.is-invalid]="
                formEmpresa.get('direccion')?.invalid &&
                (formEmpresa.get('direccion')?.touched || validate)
              " />
                  <div *ngIf="
                formEmpresa.get('direccion')?.invalid &&
                (formEmpresa.get('direccion')?.touched || validate)
              " class="invalid-feedback">
                    Por favor, ingresa una dirección.
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label"><strong>Ciudad *:</strong></label>
                  <ng-select #inputCiudad id="ciudad" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                    placeholder="Selecciona una opción" formControlName="ciudad">
                  </ng-select>
                  <div *ngIf="
                formEmpresa.get('ciudad')?.invalid &&
                (formEmpresa.get('ciudad')?.touched || validate)
              " class="invalid-feedback">
                    Por favor, ingresa una ciudad.
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="telefono"><strong>Teléfono Fijo:</strong></label>
                  <input class="form-control" id="telefono" type="number" inputmode="numeric"
                    placeholder="Ingresa el teléfono fijo" formControlName="telefono"
                    (input)="limitarLongitud($event, 10)" />
                  <div *ngIf="
                formEmpresa.get('telefono')?.invalid &&
                formEmpresa.get('telefono')?.touched
              " class="invalid-feedback">
                    El teléfono fijo debe tener 10 dígitos.
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="celular"><strong>Teléfono Celular *:</strong></label>
                  <input #inputCelular class="form-control" id="celular" type="number"
                    placeholder="Ingresa el teléfono celular" formControlName="celular"
                    (input)="limitarLongitud($event, 10)" [class.is-invalid]="
                formEmpresa.get('celular')?.invalid &&
                (formEmpresa.get('celular')?.touched || validate)
              " />
                  <div *ngIf="
                formEmpresa.get('celular')?.invalid &&
                (formEmpresa.get('celular')?.touched || validate)
              " class="invalid-feedback">
                    Por favor, ingresa un número de celular de 10 dígitos.
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="email">
                    <strong>Correo Electrónico *:</strong></label>
                  <input #inputEmail class="form-control" id="email" type="text" required
                    placeholder="Ingresa un correo valido" formControlName="email" [class.is-invalid]="
                formEmpresa.get('email')?.invalid &&
                (formEmpresa.get('email')?.touched || validate)
              " />
                  <div *ngIf="
                formEmpresa.get('email')?.invalid &&
                (formEmpresa.get('email')?.touched || validate)
              " class="invalid-feedback">
                    Por favor, ingresa un correo electronico.
                  </div>
                </div>

                <div class="row g-3 mb-3">
                  <div class="mb-3">
                    <label><strong>Observaciones:</strong></label>
                    <textarea class="form-control" id="observaciones" rows="3"
                      formControlName="observaciones"></textarea>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button class="btn btn-primary" (click)="guardarEmpresa(modalEmpresaRef)">
              Guardar
            </button>
            <button class="btn btn-secondary" (click)="modal.dismiss()">
              Cancelar
            </button>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-11">
      <ng-template ngbPanelTitle>
        <i class="icofont icofont-read-book-alt"></i>
        <span class="ms-2">Capacitaciones</span>
      </ng-template>

      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-header bg-primary">
            <h5 class="text-uppercase text-white">
              Listado de Capacitaciones
            </h5>
          </div>
          <div class="custom-datatable table-responsive mt-2 container-fluid">
            <table class="table table-hover table-bordered" id="tblAsistencias">
              <thead class="bg-primary">
                <tr>

                  <th class="text-center" style="cursor: pointer">
                    <strong>CAPACITACIÓN</strong>
                    <i class="fa"></i>
                  </th>

                  <th class="text-center" style="cursor: pointer">
                    <strong>CÉDULA</strong>
                    <i class="fa"></i>
                  </th>

                  <th class="text-center" style="cursor: pointer">
                    <strong>NOMBRE</strong>
                    <i class="fa"></i>
                  </th>

                  <th class="text-center"><strong>ASISTIÓ</strong></th>
                  <th class="text-center"><strong>APROBADO</strong></th>
                  <th class="text-center"><strong>CALIFICACIÓN</strong></th>

                  <th class="text-center"><strong>ACCIONES</strong></th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let asistente of asistentes | paginate : { itemsPerPage: pageSize, currentPage: page }">

                  <td class="text-uppercase">
                    {{ asistente.capacitacion?.nombre || "-" }}
                  </td>

                  <td class="text-center">
                    {{ asistente.cedula || "-" }}
                  </td>

                  <td class="text-uppercase">
                    {{ asistente.nombre || "-" }}
                  </td>

                  <td class="text-center">
                    <span class="badge" [ngClass]="asistioLabel(asistente) ? 'bg-success' : 'bg-danger'">
                      {{ asistioLabel(asistente) ? "Sí" : "No" }}
                    </span>
                  </td>

                  <td class="text-center">
                    <span class="badge" [ngClass]="aprobadoLabel(asistente) ? 'bg-success' : 'bg-danger'">
                      {{ aprobadoLabel(asistente) ? "Sí" : "No" }}
                    </span>
                  </td>

                  <td class="text-center">
                    {{ asistente.calificacion ?? "-" }}
                  </td>
                  <td class="text-center">
                    <div class="action">
                      <ul class="list-inline m-0">
                        <li class="edit list-inline-item"
                          (click)="abrirModalEditarAsistente(asistente, editAsistenciaModal)">
                          <a href="javascript:void(0)">
                            <i class="icon-pencil-alt" ngbTooltip="Editar"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>


                </tr>
                <tr *ngIf="!loading && asistentes.length === 0">
                  <td [attr.colspan]="modoEmbebido ? 7 : 8" class="text-center text-primary py-4">
                    No hay asistentes registrados para esta capacitación.
                  </td>
                </tr>

              </tbody>
            </table>

            <div class="d-flex justify-content-between align-items-center mt-4">
              <div class="d-flex align-items-center">
                <label for="pageSize" class="me-2 text-dark"> Mostrar: </label>

                <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                  <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">
                    {{ size }}
                  </option>
                </select>

                <span class="ms-2"> registros por página </span>
              </div>

              <div class="text-center flex-grow-1 text-dark">
                Total Registros:
                <a class="badge badge-primary">
                  <b>{{ asistentes?.length }}</b>
                </a>
              </div>

              <div class="text-end paginador-personalizado">
                <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                  [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                </pagination-controls>
              </div>
            </div>
          </div>


          <!-- BOTONES -->
          <div class="mt-4" *ngIf="!modoEmbebido">
            <div class="btn-showcase text-center">
              <button class="btn btn-outline-success-2x" type="button"
                (click)="exportarExcel('tblAsistencias', 'Listado_asistencias')">
                <i class="icofont icofont-file-excel"></i>
                EXCEL
              </button>

              <button class="btn btn-outline-danger-2x" type="button" (click)="
                exportToPDF(
                  'tblAsistencias',
                  'Listado_asistencias',
                  'Listado de Asistencias a Capacitaciones'
                )
              ">
                <i class="icofont icofont-file-pdf"></i>
                PDF
              </button>

              <button class="btn btn-outline-primary-2x" type="button"
                (click)="abrirModalNuevoAsistente(createAsistenciaModal)">
                <i class="fa fa-plus"></i>
                CREAR
              </button>
            </div>
          </div>
        </div>


      </ng-template>

      <ng-template #editAsistenciaModal let-modal>
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title mb-0"><strong> EDITAR ASISTENCIA </strong></h5>
          <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>

        <div class="modal-body">
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label text-dark">
                <strong>Capacitación:</strong>
                <a class="text-danger">*</a>
              </label>
              <ng-select [items]="programacionActivosData" bindLabel="nombreCapacitacion" bindValue="id"
                [(ngModel)]="editAsistenciaForm.capacitacion_id" placeholder="Seleccione..." [clearable]="false">
              </ng-select>
            </div>

            <div class="col-md-4">
              <label class="form-label text-dark">
                <strong>Número de Documento:</strong>
                <a class="text-danger">*</a>
              </label>
              <input type="number" class="form-control" [(ngModel)]="editAsistenciaForm.cedula" disabled />
            </div>

            <div class="col-md-4">
              <label class="form-label text-dark">
                <strong>Nombre:</strong>
                <a class="text-danger">*</a>
              </label>
              <input type="text" class="form-control text-uppercase" [(ngModel)]="editAsistenciaForm.nombre" disabled />
            </div>

            <div class="col-md-4">
              <label class="form-label text-dark">
                <strong>Calificación:</strong></label>
              <input type="number" class="form-control" [(ngModel)]="editAsistenciaForm.calificacion" />
            </div>

            <div class="col-md-4">
              <label class="form-label text-dark">
                <strong>Asistió:</strong></label>
              <ng-select [items]="[
    { id: 1, nombre: 'Sí' },
    { id: 0, nombre: 'No' }
  ]" bindLabel="nombre" bindValue="id" [(ngModel)]="editAsistenciaForm.asistio" [clearable]="false">
              </ng-select>
            </div>

            <div class="col-md-4">
              <label class="form-label text-dark">
                <strong>Aprobado:</strong></label>
              <ng-select [items]="[
    { id: 1, nombre: 'Sí' },
    { id: 0, nombre: 'No' }
  ]" bindLabel="nombre" bindValue="id" [(ngModel)]="editAsistenciaForm.aprobado" [clearable]="false">
              </ng-select>
            </div>

          <!--   <div class="col-md-12 mt-4" *ngIf="editAsistenciaForm.aprobado == 1">


              <input type="file" class="d-none" (change)="onFileSelectedEdit($event)" id="editDocumentoInput"
                accept="application/pdf,.pdf">

              <label for="editDocumentoInput"
                class="w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer">

                <ng-container *ngIf="selectedFileEdit; else noDocumentoEdit">

                  <div *ngIf="!isImage(selectedFileEdit)"
                    class="pdf-preview-icon d-flex flex-column align-items-center text-danger mb-2">

                    <i class="fa fa-file-pdf-o fs-1"></i>

                    <small>Archivo PDF</small>
                  </div>

                  <img *ngIf="isImage(selectedFileEdit)" [src]="previewEdit" class="preview-img mb-2 rounded shadow-sm">

                  <small class="text-muted text-truncate">
                    {{ selectedFileEdit.name }}
                  </small>

                </ng-container>

                <ng-template #noDocumentoEdit>

                  <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>

                  <p class="mb-2 fw-semibold text-primary text-center">
                    Haz click para cargar
                  </p>

                  <span class="btn btn-primary btn-sm rounded-pill px-3">
                    Cargar soporte
                  </span>

                </ng-template>

              </label>

            </div> -->

            <div class="col-md-12">
              <label class="form-label text-dark">
                <strong>Observaciones:</strong></label>
              <textarea rows="4" class="form-control" [(ngModel)]="editAsistenciaForm.observaciones"></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
          <button type="button" class="btn btn-primary" [disabled]="loading" (click)="guardarEdicionAsistencia()">
            <span *ngIf="!loading"> Actualizar </span>
            <span *ngIf="loading"> Guardando... </span>
          </button>
        </div>
      </ng-template>

      <ng-template #createAsistenciaModal let-modal>
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title mb-0">
            <strong>
              NUEVA ASISTENCIA
            </strong>
          </h5>
          <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>

        <div class="modal-body">
          <div class="row g-3">

            <div class="col-md-4" *ngIf="!modoEmbebido">
              <label class="form-label text-dark">
                <strong>Capacitación:</strong>
                <a class="text-danger"> *</a>
              </label>

              <ng-select [items]="programacionActivosData" bindLabel="nombreCapacitacion" bindValue="id"
                [(ngModel)]="newAsistenciaForm.capacitacion_id" placeholder="Seleccione..." [clearable]="false">
              </ng-select>
            </div>

            <div class="col-md-4">
              <label class="form-label text-dark">
                <strong>Número de Documento:</strong>
                <a class="text-danger"> *</a>
              </label>
              <input type="number" class="form-control" placeholder="Ej. 1098765432"
                [(ngModel)]="newAsistenciaForm.cedula" disabled />
            </div>

            <div class="col-md-4">
              <label class="form-label text-dark">
                <strong>Nombre:</strong>
                <a class="text-danger"> *</a>
              </label>
              <input type="text" class="form-control text-uppercase" placeholder="Ej. Juan Pérez"
                [(ngModel)]="newAsistenciaForm.nombre" disabled />
            </div>

            <div class="col-md-4">
              <label class="form-label text-dark">
                <strong>Calificación:</strong></label>
              <input type="number" class="form-control" [(ngModel)]="newAsistenciaForm.calificacion" />
            </div>

            <div class="col-md-4">
              <label class="form-label text-dark">
                <strong>Asistió:</strong></label>
              <ng-select [items]="[
          { id: 1, nombre: 'Sí' },
          { id: 0, nombre: 'No' }
        ]" bindLabel="nombre" bindValue="id" [(ngModel)]="newAsistenciaForm.asistio" [clearable]="false">
              </ng-select>
            </div>

            <div class="col-md-4">
              <label class="form-label text-dark">
                <strong>Aprobado:</strong></label>
              <ng-select [items]="[
          { id: 1, nombre: 'Sí' },
          { id: 0, nombre: 'No' }
        ]" bindLabel="nombre" bindValue="id" [(ngModel)]="newAsistenciaForm.aprobado" [clearable]="false">
              </ng-select>
            </div>

            <div class="col-md-12 mt-4" *ngIf="newAsistenciaForm.aprobado == 1">


             <!--  <input type="file" class="d-none" (change)="onFileSelectedEdit($event)" id="editDocumentoInput"
                accept=".pdf,.jpg,.jpeg,.png">

              <label for="editDocumentoInput"
                class="w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer">

                <ng-container *ngIf="selectedFileEdit; else noDocumentoEdit">

                  <div *ngIf="!isImage(selectedFileEdit)"
                    class="pdf-preview-icon d-flex flex-column align-items-center text-danger mb-2">

                    <i class="fa fa-file-pdf-o fs-1"></i>

                    <small>Archivo PDF</small>
                  </div>

                  <img *ngIf="isImage(selectedFileEdit)" [src]="previewEdit" class="preview-img mb-2 rounded shadow-sm">

                  <small class="text-muted text-truncate">
                    {{ selectedFileEdit.name }}
                  </small>

                </ng-container>

                <ng-template #noDocumentoEdit>

                  <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>

                  <p class="mb-2 fw-semibold text-primary text-center">
                    Haz click para cargar
                  </p>

                  <span class="btn btn-primary btn-sm rounded-pill px-3">
                    Cargar soporte
                  </span>

                </ng-template>

              </label> -->

            </div>

            <div class="col-md-12">
              <label class="form-label text-dark">
                <strong>Observaciones:</strong></label>
              <textarea rows="4" class="form-control" [(ngModel)]="newAsistenciaForm.observaciones"></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
          <button type="button" class="btn btn-primary" [disabled]="loading" (click)="guardarNuevaAsistencia()">
            <span *ngIf="!loading"> Guardar </span>
            <span *ngIf="loading"> Guardando... </span>
          </button>
        </div>
      </ng-template>

    </ngb-panel>

  </ngb-accordion>
</div>

<div class="btn-showcase my-4">
  <button type="submit" class="btn btn-primary" (click)="withConfirmation()">
    Actualizar
  </button>
</div>

<ng-template #myModal2 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>CREACIÓN DE ENTIDADES / EMPRESAS</strong></h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formEmpresa">
        <!-- Inputs antes de la tabla -->
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label" for="nit"><strong>CC / NIT *:</strong></label>
            <input class="form-control" id="nit" type="number" placeholder="Ingrese CC o NIT" formControlName="nit"
              (input)="limitarLongitud($event, 10)" [class.is-invalid]="
                formEmpresa.get('nit')?.invalid &&
                (formEmpresa.get('nit')?.touched || validate)
              " />
            <div *ngIf="
                formEmpresa.get('nit')?.invalid &&
                (formEmpresa.get('nit')?.touched || validate)
              " class="invalid-feedback">
              Por favor, ingresa un número de documento.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="digito">
              <strong>Digito de Verificacción *:</strong></label>
            <input #inputCodigo class="form-control" id="digito" type="number" required
              placeholder="Ingrese el dígito de verificación" formControlName="digito" [class.is-invalid]="
                formEmpresa.get('digito')?.invalid &&
                (formEmpresa.get('digito')?.touched || validate)
              " />
            <div *ngIf="
                formEmpresa.get('digito')?.invalid &&
                (formEmpresa.get('digito')?.touched || validate)
              " class="invalid-feedback">
              Por favor, ingresa un digito de verificación.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="nombre"><strong>Nombre Completo/Razon Social *:</strong></label>
            <input #inputNombre class="form-control" id="nombre" type="text"
              placeholder="Ingrese el nombre o razon social" required formControlName="nombre" [class.is-invalid]="
                formEmpresa.get('nombre')?.invalid &&
                (formEmpresa.get('nombre')?.touched || validate)
              " />
            <div *ngIf="
                formEmpresa.get('nombre')?.invalid &&
                (formEmpresa.get('nombre')?.touched || validate)
              " class="invalid-feedback">
              Por favor, ingresa un nombre o razón social.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="direccion">
              <strong>Dirección *:</strong></label>
            <input #inputDireccion class="form-control" id="direccion" type="text" required
              placeholder="Ingresa una dirección" formControlName="direccion" [class.is-invalid]="
                formEmpresa.get('direccion')?.invalid &&
                (formEmpresa.get('direccion')?.touched || validate)
              " />
            <div *ngIf="
                formEmpresa.get('direccion')?.invalid &&
                (formEmpresa.get('direccion')?.touched || validate)
              " class="invalid-feedback">
              Por favor, ingresa una dirección.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label"><strong>Ciudad *:</strong></label>
            <ng-select #inputCiudad id="ciudad" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
              placeholder="Selecciona una opción" formControlName="ciudad">
            </ng-select>
            <div *ngIf="
                formEmpresa.get('ciudad')?.invalid &&
                (formEmpresa.get('ciudad')?.touched || validate)
              " class="invalid-feedback">
              Por favor, ingresa una ciudad.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="telefono"><strong>Teléfono Fijo:</strong></label>
            <input class="form-control" id="telefono" type="number" inputmode="numeric"
              placeholder="Ingresa el teléfono fijo" formControlName="telefono" (input)="limitarLongitud($event, 10)" />
            <div *ngIf="
                formEmpresa.get('telefono')?.invalid &&
                formEmpresa.get('telefono')?.touched
              " class="invalid-feedback">
              El teléfono fijo debe tener 10 dígitos.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="celular"><strong>Teléfono Celular *:</strong></label>
            <input #inputCelular class="form-control" id="celular" type="number"
              placeholder="Ingresa el teléfono celular" formControlName="celular" (input)="limitarLongitud($event, 10)"
              [class.is-invalid]="
                formEmpresa.get('celular')?.invalid &&
                (formEmpresa.get('celular')?.touched || validate)
              " />
            <div *ngIf="
                formEmpresa.get('celular')?.invalid &&
                (formEmpresa.get('celular')?.touched || validate)
              " class="invalid-feedback">
              Por favor, ingresa un número de celular de 10 dígitos.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="email">
              <strong>Correo Electrónico *:</strong></label>
            <input #inputEmail class="form-control" id="email" type="text" required
              placeholder="Ingresa un correo valido" formControlName="email" [class.is-invalid]="
                formEmpresa.get('email')?.invalid &&
                (formEmpresa.get('email')?.touched || validate)
              " />
            <div *ngIf="
                formEmpresa.get('email')?.invalid &&
                (formEmpresa.get('email')?.touched || validate)
              " class="invalid-feedback">
              Por favor, ingresa un correo electronico.
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="mb-3">
              <label><strong>Observaciones:</strong></label>
              <textarea class="form-control" id="observaciones" rows="3" formControlName="observaciones"></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarEmpresa(modalEmpresaRef)">
        Guardar
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>
